var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormFieldsContainer",
    [
      _c(
        "v-flex",
        { attrs: { md3: "" } },
        [
          _c("v-text-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|numeric|max:3|max_value:120|min_value:1",
                expression: "'required|numeric|max:3|max_value:120|min_value:1'"
              }
            ],
            attrs: {
              label: _vm.formFields.limiteVelocidad.label,
              id: _vm.formFields.limiteVelocidad.id,
              "prepend-icon": "network_check",
              "error-messages": _vm.errors.collect("velMax"),
              "data-vv-name": "velMax",
              counter: 3,
              disabled: _vm.accion === 3
            },
            on: { change: _vm.handleLimiteVelocidad },
            model: {
              value: _vm.formFields.limiteVelocidad.value,
              callback: function($$v) {
                _vm.$set(_vm.formFields.limiteVelocidad, "value", $$v)
              },
              expression: "formFields.limiteVelocidad.value"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }